import { useContext } from 'react';

import { FormGroupContext } from '@/components/FormGroup';

export const useReviewMode = () => {
  const ctx = useContext(FormGroupContext);

  return Boolean(ctx?.reviewMode);
};
